import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import {
  ProgressBar,
  Step
} from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  LA_TEST,
} from '../../constants.js';
import {
  getScrollBase,
} from './functions.js';
import TestResult from './TestResult';
import s from './LossAversionLight.css';
import cs from './common.css';

class LossAversionLight extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      questions: [1,2,3,4,5,6,7,8,9,10],
      qNum: 0,
      answers: Array.from({length: 10}),
    };
  }

  componentWillMount() {
    this.generateQuestions();
    this.getNextQuestion();
  }

  getNextQuestion() {
    const {
      answers
    } = this.state;
    const questions = [].concat(this.state.questions);
    let qNum = 11;
    // if more questions get and remove one randomly
    if(questions.length > 0) {
      const index = Math.floor(Math.random() * questions.length);
      qNum = questions[index];
      questions.splice(index,1);
    }
    // update the state with current num and remaining questions
    if(qNum === 11) {
      this.props.saveScore(LA_TEST, answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerQuestion(gamble) {
    const {
      qNum,
    } = this.state;
    const answers = [].concat(this.state.answers);
    // set answer, get next question
    answers[qNum - 1] = gamble;
    this.setState(Object.assign({}, this.state, {
      answers: answers,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
      questions,
      panes,
    } = this.state;
    if(qNum === 11) {
      return (
        <TestResult />
      );
    } else {
      const scrollBase = getScrollBase();
      const ctrans = `translate(${-(((this.state.qNum - 1) * 30) + ((this.state.qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
              <ProgressBar
                unfilledBackground="#BDC2C6"
                filledBackground="#35ccd2"
                height='1px'
                percent={100 / 9 * (9 - questions.length)}
              >
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
              </ProgressBar>
              </div>
              {/* <div className={cs.headerTitle}>Loss Aversion</div> */}
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{overflow: 'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{transform: ctrans}}>
                { panes }
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    const questionVals = [200, 300, 350, 400, 500, 600, 700, 900, 1100, 2100];
    const gambles = [];
    const panes = questionVals.map((val) => {
      const order = Math.floor((Math.random() * 2));
      gambles.push(order === 0 ? [1,0] : [0,1]);
      return (
        <div key={val} className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>Please choose which gamble you would prefer.  Each gamble has three equally likely outcomes.</div>
          <div className="row">
            <div className={'col-md-3'} />
            { order === 0 &&
            <div className={'col-md-3 ' + s.gambleBox} onClick={() => this.answerQuestion(1)}>
              <div className={s.gamble}>Gamble 1</div>
              <div className={s.trafficLight}>
                <div className={s.tl + ' ' + s.tlGreen}>$100</div>
                <div className={s.tl + ' ' + s.tlYellow}>$0</div>
                <div className={s.tl + ' ' + s.tlRed}>$-100</div>
              </div>
            </div>
            }
            <div className={'col-md-3 ' + s.gambleBox} onClick={() => this.answerQuestion(0)}>
              <div className={s.gamble}>Gamble {order === 0 ? 2:1}</div>
              <div className={s.trafficLight}>
                <div className={s.tl + ' ' + s.tlGreen}>${val}</div>
                <div className={s.tl + ' ' + s.tlYellow}>$0</div>
                <div className={s.tl + ' ' + s.tlRed}>$-300</div>
              </div>
            </div>
            { order === 1 &&
            <div className={'col-md-3 ' + s.gambleBox} onClick={() => this.answerQuestion(1)}>
              <div className={s.gamble}>Gamble 2</div>
              <div className={s.trafficLight}>
                <div className={s.tl + ' ' + s.tlGreen}>$100</div>
                <div className={s.tl + ' ' + s.tlYellow}>$0</div>
                <div className={s.tl + ' ' + s.tlRed}>$-100</div>
              </div>
            </div>
            }
            <div className={'col-md-3'} />
          </div>
        </div>
      );
    });
    this.setState(Object.assign({}, this.state, {
      panes: panes,
      gambles: gambles,
    }));
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(LossAversionLight);



// WEBPACK FOOTER //
// ./src/components/ClientMode/LossAversionLight.js